export default __webpack_public_path__ + "static/media/facebook-check-pages.d2304d90.jpg";